/**
 * Force redirect to homepage after successful customer login
 * This handles edge cases where Shopify's default B2B behavior 
 * redirects to the orders page
 */
(function() {
  'use strict';

  // Check if we just logged in and should redirect to homepage
  function checkLoginRedirect() {
    // Check if we're on the account page (where Shopify redirects by default)
    const isAccountPage = window.location.pathname.includes('/account');
    const justLoggedIn = document.referrer.includes('/account/login') || 
                         document.referrer.includes('/login');
    
    // Check for a session flag indicating we should redirect
    const shouldRedirect = sessionStorage.getItem('redirect_to_home');
    
    if (isAccountPage && (justLoggedIn || shouldRedirect)) {
      // Clear the flag
      sessionStorage.removeItem('redirect_to_home');
      
      // Redirect to homepage
      window.location.href = '/';
    }
  }

  // Set a flag when the login form is submitted
  function setupLoginForm() {
    const loginForms = document.querySelectorAll('form[action*="account/login"], form[action*="customer_login"]');
    
    loginForms.forEach(form => {
      form.addEventListener('submit', function() {
        // Set a session flag that we want to redirect to homepage
        sessionStorage.setItem('redirect_to_home', 'true');
      });
    });
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setupLoginForm();
      checkLoginRedirect();
    });
  } else {
    setupLoginForm();
    checkLoginRedirect();
  }
})();

